// extracted by mini-css-extract-plugin
export default {"cls1":"Icons-cls1_a71","cls2":"Icons-cls2_ltG Icons-cls1_a71"};